module.exports = __webpack_public_path__ + "img/banner_4.dc18b328.jpg";